/* tslint:disable */
/* eslint-disable */
/**
 * grpc/knowledge/page.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { KnowledgeCreatePageRequest } from '../models'
// @ts-ignore
import type { KnowledgeGetPageTreeResponse } from '../models'
// @ts-ignore
import type { KnowledgeListAttachmentsResponse } from '../models'
// @ts-ignore
import type { KnowledgeListIssueLinksResponse } from '../models'
// @ts-ignore
import type { KnowledgeListPageVersionsResponse } from '../models'
// @ts-ignore
import type { KnowledgePageAttachmentResponse } from '../models'
// @ts-ignore
import type { KnowledgePageIssueLinkResponse } from '../models'
// @ts-ignore
import type { KnowledgePageResponse } from '../models'
// @ts-ignore
import type { KnowledgePageVersionResponse } from '../models'
// @ts-ignore
import type { KnowledgeSearchPagesResponse } from '../models'
// @ts-ignore
import type { PageServiceAttachFileBody } from '../models'
// @ts-ignore
import type { PageServiceLinkIssueBody } from '../models'
// @ts-ignore
import type { PageServiceMovePageBody } from '../models'
// @ts-ignore
import type { PageServiceSavePageVersionBody } from '../models'
// @ts-ignore
import type { PageServiceUpdatePageBody } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
/**
 * PageServiceApi - axios parameter creator
 */
export const PageServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a page. Bytes go to files-service first; this records what the page keeps.
     * @param {string} pageId
     * @param {PageServiceAttachFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceAttachFile: async (
      pageId: string,
      body: PageServiceAttachFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceAttachFile', 'pageId', pageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceAttachFile', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/attachments`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a page. Without a parent it lands at the root of its space.
     * @param {KnowledgeCreatePageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceCreatePage: async (
      body: KnowledgeCreatePageRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceCreatePage', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Detaches a file from a page.
     * @param {string} pageId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceDeleteAttachment: async (
      pageId: string,
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceDeleteAttachment', 'pageId', pageId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pageServiceDeleteAttachment', 'id', id)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/attachments/{id}`
        .replace('{pageId}', encodeURIComponent(String(pageId)))
        .replace('{id}', encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a page together with everything under it. Soft delete.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceDeletePage: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pageServiceDeletePage', 'id', id)
      const localVarPath = `/api/v1/knowledge/pages/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one page with its body.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPage: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pageServiceGetPage', 'id', id)
      const localVarPath = `/api/v1/knowledge/pages/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one level of a space\'s tree: the children of the given parent, or the root pages when no parent is given. One level, not the whole tree — a space with a thousand pages must not cost a thousand rows to draw a sidebar.
     * @param {string} spaceId
     * @param {string} [parentId] Children of this page. Left out — the root level of the space.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPageTree: async (
      spaceId: string,
      parentId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('pageServiceGetPageTree', 'spaceId', spaceId)
      const localVarPath = `/api/v1/knowledge/spaces/{spaceId}/tree`.replace(
        '{spaceId}',
        encodeURIComponent(String(spaceId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (parentId !== undefined) {
        localVarQueryParameter['parentId'] = parentId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one version with its body — that is what a diff view reads.
     * @param {string} pageId
     * @param {string} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPageVersion: async (
      pageId: string,
      number: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceGetPageVersion', 'pageId', pageId)
      // verify required parameter 'number' is not null or undefined
      assertParamExists('pageServiceGetPageVersion', 'number', number)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/versions/{number}`
        .replace('{pageId}', encodeURIComponent(String(pageId)))
        .replace('{number}', encodeURIComponent(String(number)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Links a page to a task. The key is checked against the tracker: a link to a task that does not exist is worse than no link, because it reads as proof that the work is tracked.
     * @param {string} pageId
     * @param {PageServiceLinkIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceLinkIssue: async (
      pageId: string,
      body: PageServiceLinkIssueBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceLinkIssue', 'pageId', pageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceLinkIssue', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/issues`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists a page\'s attachments.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListAttachments: async (
      pageId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceListAttachments', 'pageId', pageId)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/attachments`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the tasks a page is linked to.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListIssueLinks: async (
      pageId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceListIssueLinks', 'pageId', pageId)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/issues`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the versions of a page, newest first, without their bodies.
     * @param {string} pageId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListPageVersions: async (
      pageId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceListPageVersions', 'pageId', pageId)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/versions`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Moves a page to another parent, another position, or both. Moving a page takes its whole subtree with it.
     * @param {string} id
     * @param {PageServiceMovePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceMovePage: async (
      id: string,
      body: PageServiceMovePageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pageServiceMovePage', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceMovePage', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{id}:move`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Puts an old version back as the current content. The state before the restore is saved as a version first, so a restore is itself undoable.
     * @param {string} pageId
     * @param {string} number
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceRestorePageVersion: async (
      pageId: string,
      number: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceRestorePageVersion', 'pageId', pageId)
      // verify required parameter 'number' is not null or undefined
      assertParamExists('pageServiceRestorePageVersion', 'number', number)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceRestorePageVersion', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/versions/{number}:restore`
        .replace('{pageId}', encodeURIComponent(String(pageId)))
        .replace('{number}', encodeURIComponent(String(number)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Saves the current state of a page as a version. Explicit on purpose: autosave writes through UpdatePage, and if every keystroke made a version the history would be useless within a day.
     * @param {string} pageId
     * @param {PageServiceSavePageVersionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceSavePageVersion: async (
      pageId: string,
      body: PageServiceSavePageVersionBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceSavePageVersion', 'pageId', pageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceSavePageVersion', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/versions`.replace(
        '{pageId}',
        encodeURIComponent(String(pageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Full-text search over titles and bodies.
     * @param {string} [query]
     * @param {Array<string>} [spaceIds] Narrow the search to these spaces. Empty — search all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceSearchPages: async (
      query?: string,
      spaceIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/knowledge/pages:search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (spaceIds) {
        localVarQueryParameter['spaceIds'] = spaceIds
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes a link to a task.
     * @param {string} pageId
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceUnlinkIssue: async (
      pageId: string,
      issueKey: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageId' is not null or undefined
      assertParamExists('pageServiceUnlinkIssue', 'pageId', pageId)
      // verify required parameter 'issueKey' is not null or undefined
      assertParamExists('pageServiceUnlinkIssue', 'issueKey', issueKey)
      const localVarPath = `/api/v1/knowledge/pages/{pageId}/issues/{issueKey}`
        .replace('{pageId}', encodeURIComponent(String(pageId)))
        .replace('{issueKey}', encodeURIComponent(String(issueKey)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a page. This is also what autosave calls, and it deliberately does not create a version — see SavePageVersion.
     * @param {string} id
     * @param {PageServiceUpdatePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceUpdatePage: async (
      id: string,
      body: PageServiceUpdatePageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pageServiceUpdatePage', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pageServiceUpdatePage', 'body', body)
      const localVarPath = `/api/v1/knowledge/pages/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PageServiceApi - functional programming interface
 */
export const PageServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PageServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a page. Bytes go to files-service first; this records what the page keeps.
     * @param {string} pageId
     * @param {PageServiceAttachFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceAttachFile(
      pageId: string,
      body: PageServiceAttachFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageAttachmentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceAttachFile(
        pageId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceAttachFile']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a page. Without a parent it lands at the root of its space.
     * @param {KnowledgeCreatePageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceCreatePage(
      body: KnowledgeCreatePageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceCreatePage(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceCreatePage']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Detaches a file from a page.
     * @param {string} pageId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceDeleteAttachment(
      pageId: string,
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceDeleteAttachment(
        pageId,
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceDeleteAttachment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a page together with everything under it. Soft delete.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceDeletePage(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceDeletePage(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceDeletePage']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one page with its body.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceGetPage(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceGetPage(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceGetPage']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one level of a space\'s tree: the children of the given parent, or the root pages when no parent is given. One level, not the whole tree — a space with a thousand pages must not cost a thousand rows to draw a sidebar.
     * @param {string} spaceId
     * @param {string} [parentId] Children of this page. Left out — the root level of the space.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceGetPageTree(
      spaceId: string,
      parentId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeGetPageTreeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceGetPageTree(
        spaceId,
        parentId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceGetPageTree']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one version with its body — that is what a diff view reads.
     * @param {string} pageId
     * @param {string} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceGetPageVersion(
      pageId: string,
      number: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageVersionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceGetPageVersion(
        pageId,
        number,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceGetPageVersion']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Links a page to a task. The key is checked against the tracker: a link to a task that does not exist is worse than no link, because it reads as proof that the work is tracked.
     * @param {string} pageId
     * @param {PageServiceLinkIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceLinkIssue(
      pageId: string,
      body: PageServiceLinkIssueBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageIssueLinkResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceLinkIssue(
        pageId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceLinkIssue']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists a page\'s attachments.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceListAttachments(
      pageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeListAttachmentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceListAttachments(
        pageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceListAttachments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the tasks a page is linked to.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceListIssueLinks(
      pageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeListIssueLinksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceListIssueLinks(
        pageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceListIssueLinks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the versions of a page, newest first, without their bodies.
     * @param {string} pageId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceListPageVersions(
      pageId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeListPageVersionsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceListPageVersions(
        pageId,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceListPageVersions']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Moves a page to another parent, another position, or both. Moving a page takes its whole subtree with it.
     * @param {string} id
     * @param {PageServiceMovePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceMovePage(
      id: string,
      body: PageServiceMovePageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceMovePage(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceMovePage']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Puts an old version back as the current content. The state before the restore is saved as a version first, so a restore is itself undoable.
     * @param {string} pageId
     * @param {string} number
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceRestorePageVersion(
      pageId: string,
      number: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceRestorePageVersion(
        pageId,
        number,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceRestorePageVersion']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Saves the current state of a page as a version. Explicit on purpose: autosave writes through UpdatePage, and if every keystroke made a version the history would be useless within a day.
     * @param {string} pageId
     * @param {PageServiceSavePageVersionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceSavePageVersion(
      pageId: string,
      body: PageServiceSavePageVersionBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageVersionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceSavePageVersion(
        pageId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceSavePageVersion']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Full-text search over titles and bodies.
     * @param {string} [query]
     * @param {Array<string>} [spaceIds] Narrow the search to these spaces. Empty — search all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceSearchPages(
      query?: string,
      spaceIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeSearchPagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceSearchPages(
        query,
        spaceIds,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceSearchPages']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes a link to a task.
     * @param {string} pageId
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceUnlinkIssue(
      pageId: string,
      issueKey: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceUnlinkIssue(
        pageId,
        issueKey,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceUnlinkIssue']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a page. This is also what autosave calls, and it deliberately does not create a version — see SavePageVersion.
     * @param {string} id
     * @param {PageServiceUpdatePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pageServiceUpdatePage(
      id: string,
      body: PageServiceUpdatePageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgePageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pageServiceUpdatePage(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PageServiceApi.pageServiceUpdatePage']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PageServiceApi - factory interface
 */
export const PageServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PageServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a page. Bytes go to files-service first; this records what the page keeps.
     * @param {string} pageId
     * @param {PageServiceAttachFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceAttachFile(
      pageId: string,
      body: PageServiceAttachFileBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageAttachmentResponse> {
      return localVarFp
        .pageServiceAttachFile(pageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a page. Without a parent it lands at the root of its space.
     * @param {KnowledgeCreatePageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceCreatePage(
      body: KnowledgeCreatePageRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageResponse> {
      return localVarFp
        .pageServiceCreatePage(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Detaches a file from a page.
     * @param {string} pageId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceDeleteAttachment(
      pageId: string,
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .pageServiceDeleteAttachment(pageId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a page together with everything under it. Soft delete.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceDeletePage(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .pageServiceDeletePage(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one page with its body.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPage(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageResponse> {
      return localVarFp.pageServiceGetPage(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one level of a space\'s tree: the children of the given parent, or the root pages when no parent is given. One level, not the whole tree — a space with a thousand pages must not cost a thousand rows to draw a sidebar.
     * @param {string} spaceId
     * @param {string} [parentId] Children of this page. Left out — the root level of the space.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPageTree(
      spaceId: string,
      parentId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeGetPageTreeResponse> {
      return localVarFp
        .pageServiceGetPageTree(spaceId, parentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one version with its body — that is what a diff view reads.
     * @param {string} pageId
     * @param {string} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceGetPageVersion(
      pageId: string,
      number: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageVersionResponse> {
      return localVarFp
        .pageServiceGetPageVersion(pageId, number, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Links a page to a task. The key is checked against the tracker: a link to a task that does not exist is worse than no link, because it reads as proof that the work is tracked.
     * @param {string} pageId
     * @param {PageServiceLinkIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceLinkIssue(
      pageId: string,
      body: PageServiceLinkIssueBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageIssueLinkResponse> {
      return localVarFp
        .pageServiceLinkIssue(pageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists a page\'s attachments.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListAttachments(
      pageId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeListAttachmentsResponse> {
      return localVarFp
        .pageServiceListAttachments(pageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the tasks a page is linked to.
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListIssueLinks(
      pageId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeListIssueLinksResponse> {
      return localVarFp
        .pageServiceListIssueLinks(pageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the versions of a page, newest first, without their bodies.
     * @param {string} pageId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceListPageVersions(
      pageId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeListPageVersionsResponse> {
      return localVarFp
        .pageServiceListPageVersions(pageId, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Moves a page to another parent, another position, or both. Moving a page takes its whole subtree with it.
     * @param {string} id
     * @param {PageServiceMovePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceMovePage(
      id: string,
      body: PageServiceMovePageBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageResponse> {
      return localVarFp
        .pageServiceMovePage(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Puts an old version back as the current content. The state before the restore is saved as a version first, so a restore is itself undoable.
     * @param {string} pageId
     * @param {string} number
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceRestorePageVersion(
      pageId: string,
      number: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageResponse> {
      return localVarFp
        .pageServiceRestorePageVersion(pageId, number, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Saves the current state of a page as a version. Explicit on purpose: autosave writes through UpdatePage, and if every keystroke made a version the history would be useless within a day.
     * @param {string} pageId
     * @param {PageServiceSavePageVersionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceSavePageVersion(
      pageId: string,
      body: PageServiceSavePageVersionBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageVersionResponse> {
      return localVarFp
        .pageServiceSavePageVersion(pageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Full-text search over titles and bodies.
     * @param {string} [query]
     * @param {Array<string>} [spaceIds] Narrow the search to these spaces. Empty — search all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceSearchPages(
      query?: string,
      spaceIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeSearchPagesResponse> {
      return localVarFp
        .pageServiceSearchPages(query, spaceIds, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes a link to a task.
     * @param {string} pageId
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceUnlinkIssue(
      pageId: string,
      issueKey: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .pageServiceUnlinkIssue(pageId, issueKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a page. This is also what autosave calls, and it deliberately does not create a version — see SavePageVersion.
     * @param {string} id
     * @param {PageServiceUpdatePageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pageServiceUpdatePage(
      id: string,
      body: PageServiceUpdatePageBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgePageResponse> {
      return localVarFp
        .pageServiceUpdatePage(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PageServiceApi - object-oriented interface
 */
export class PageServiceApi extends BaseAPI {
  /**
   *
   * @summary Attaches an already uploaded file to a page. Bytes go to files-service first; this records what the page keeps.
   * @param {string} pageId
   * @param {PageServiceAttachFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceAttachFile(
    pageId: string,
    body: PageServiceAttachFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceAttachFile(pageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a page. Without a parent it lands at the root of its space.
   * @param {KnowledgeCreatePageRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceCreatePage(body: KnowledgeCreatePageRequest, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceCreatePage(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Detaches a file from a page.
   * @param {string} pageId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceDeleteAttachment(pageId: string, id: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceDeleteAttachment(pageId, id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a page together with everything under it. Soft delete.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceDeletePage(id: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceDeletePage(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one page with its body.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceGetPage(id: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceGetPage(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one level of a space\'s tree: the children of the given parent, or the root pages when no parent is given. One level, not the whole tree — a space with a thousand pages must not cost a thousand rows to draw a sidebar.
   * @param {string} spaceId
   * @param {string} [parentId] Children of this page. Left out — the root level of the space.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceGetPageTree(
    spaceId: string,
    parentId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceGetPageTree(spaceId, parentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one version with its body — that is what a diff view reads.
   * @param {string} pageId
   * @param {string} number
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceGetPageVersion(
    pageId: string,
    number: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceGetPageVersion(pageId, number, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Links a page to a task. The key is checked against the tracker: a link to a task that does not exist is worse than no link, because it reads as proof that the work is tracked.
   * @param {string} pageId
   * @param {PageServiceLinkIssueBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceLinkIssue(
    pageId: string,
    body: PageServiceLinkIssueBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceLinkIssue(pageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists a page\'s attachments.
   * @param {string} pageId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceListAttachments(pageId: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceListAttachments(pageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the tasks a page is linked to.
   * @param {string} pageId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceListIssueLinks(pageId: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceListIssueLinks(pageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the versions of a page, newest first, without their bodies.
   * @param {string} pageId
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceListPageVersions(
    pageId: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceListPageVersions(pageId, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Moves a page to another parent, another position, or both. Moving a page takes its whole subtree with it.
   * @param {string} id
   * @param {PageServiceMovePageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceMovePage(
    id: string,
    body: PageServiceMovePageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceMovePage(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Puts an old version back as the current content. The state before the restore is saved as a version first, so a restore is itself undoable.
   * @param {string} pageId
   * @param {string} number
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceRestorePageVersion(
    pageId: string,
    number: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceRestorePageVersion(pageId, number, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Saves the current state of a page as a version. Explicit on purpose: autosave writes through UpdatePage, and if every keystroke made a version the history would be useless within a day.
   * @param {string} pageId
   * @param {PageServiceSavePageVersionBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceSavePageVersion(
    pageId: string,
    body: PageServiceSavePageVersionBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceSavePageVersion(pageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Full-text search over titles and bodies.
   * @param {string} [query]
   * @param {Array<string>} [spaceIds] Narrow the search to these spaces. Empty — search all of them.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceSearchPages(
    query?: string,
    spaceIds?: Array<string>,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceSearchPages(query, spaceIds, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes a link to a task.
   * @param {string} pageId
   * @param {string} issueKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceUnlinkIssue(pageId: string, issueKey: string, options?: RawAxiosRequestConfig) {
    return PageServiceApiFp(this.configuration)
      .pageServiceUnlinkIssue(pageId, issueKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a page. This is also what autosave calls, and it deliberately does not create a version — see SavePageVersion.
   * @param {string} id
   * @param {PageServiceUpdatePageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public pageServiceUpdatePage(
    id: string,
    body: PageServiceUpdatePageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PageServiceApiFp(this.configuration)
      .pageServiceUpdatePage(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
